<template>
    <div>
        <bv-top></bv-top>
        <van-form v-if="refresh" ref="form" :model="item">
            <van-notice-bar left-icon="volume-o"
                            text="尊敬的用户，注册过程中需要验证手机号码是否是在运营商备案的，请认真填写。"
                            v-show="!auth"
            />
            <van-cell :title="auth ? '身份信息' : '请填写真实身份信息'" size="large"/>
            <van-cell-group>

                <van-field
                        v-model.trim="item.name"
                        clearable
                        label="真实姓名"
                        :disabled="auth"
                        :rules="[{required: true, message: '请填写真实姓名'}]"
                />
                <van-field
                        v-model.trim="item.certNo"
                        label="身份证号码"
                        :rules="[{required: true, message: '请填写身份证号码'}]"
                        :disabled="auth"
                />
            </van-cell-group>
            <van-cell :title="auth ? '联系方式' : '请填写真实联系方式'" size="large"/>
            <van-cell-group>
                <van-field
                        v-model.trim="item.mobile"
                        clearable
                        label="手机号码"
                        :rules="auth ? [] : [{required: true, message: '请填写手机号码'}, {validator:validateMobile, message:'请输入正确的手机号'}]"
                        :disabled="auth"
                />

                <van-field
                        name="validateCode"
                        v-model="item.validateCode"
                        clearable
                        label="验证码"
                        v-show="!auth"
                        :rules="[{required: true, message: '请填写图片验证码'}]">
                    <div slot="button">
                        <img :src="imageSrc" @click="refreshValidateCode"/>
                    </div>
                </van-field>

                <van-field
                        v-model.trim="item.smsValidateCode"
                        center
                        clearable
                        label="短信验证码"
                        :rules="[{required: true, message: '请填写短信验证码'}]"
                        v-show="!auth"
                >
                    <van-button slot="button" size="small" type="primary" :disabled="!sms" plain hairline @click="selectSmsValidateCode">
                        <span v-if="sms">获取短信验证码</span>
                        <van-count-down ref="count" v-else :time="time" format="ss秒后重发" @finish="timeFinished"/>
                    </van-button>
                </van-field>
            </van-cell-group>
            <van-row type="flex" justify="center">
                <van-col span="22">
                  <!-- 注册按钮增加 loading 效果 -->
                    <van-button v-if="!auth" type="primary" size="large" @click="createUser" :loading="submitting">注册</van-button>
                  <!-- 解绑按钮：loading + 防抖 -->
                    <van-button v-else type="danger" size="large" @click="unBandUser" :loading="unLoading">解除绑定</van-button>
                </van-col>
            </van-row>
        </van-form>
    </div>
</template>

<script>

    import Top from '@/views/components/Top'
    import {CountDown, NoticeBar} from 'vant'
    import {selectSmsValidateCode, getInfo} from '@/api/authority'
    import {isMobile} from "vant/lib/utils/validate/mobile";
    // import * as res from "svg-sprite-loader";

    export default {
        name: 'Register',
        components: {
            VanCountDown: CountDown,
            VanNoticeBar: NoticeBar,
            BvTop: Top
        },
        data() {
            return {
                smallLogo: require('@/assets/small-logo.png'),
                item: {},
                time: 60 * 1000, // 单位毫秒，有效时间60S
                sms: true,
                auth: false,
                refresh: false,
                imageSrc: this.$APP_ROOT + "/api/authority/weixin/generateCode?t=" + new Date().getTime(),
                submitting: false, // 注册loading
                unLoading: false,  // 解绑loading
                lock: false, // 注册防抖锁
                unLock: false  // 解绑防抖锁
            }
        },
        mounted: function () {
            this.refresh = true
            const vm = this;
            if (this.$store.getters.token) {
                this.auth = true;
                getInfo(this.$store.getters.token).then(res => {
                    const {data} = res;
                    if (data) {
                        vm.item = Object.assign({}, vm.item, {
                            name: data.name,
                            certNo: data.certNo,
                            mobile: data.mobile
                        })
                    }
                })
            }
        },
        methods: {
          createUser() {
            // 防抖：正在提交中，直接返回
            if (this.lock) return;
            this.lock = true;
            this.submitting = true;

            this.$refs.form.validate().then(() => {
              this.$store.dispatch('user/registerUser', this.item).then(() => {
                if (this.$route.query.flag != null) {
                  window.location.href = "https://fgj.chifeng.gov.cn/zhwyh5/pages/index/realNameSuccess";
                } else {
                  this.$router.push("/" + (this.$route.query.redirectUrl ? this.$route.query.redirectUrl : ''))
                }
              }).finally(() => {
                // 无论成功失败，都释放锁
                this.lock = false;
                this.submitting = false;
              });
            }).catch(() => {
              // 校验失败也释放锁
              this.lock = false;
              this.submitting = false;
            });
          },
            validateMobile(value) {
              return value.length === 11;
                //return isMobile(value);
            },
          unBandUser() {
            if (this.unLock) return;
            this.unLock = true;
            this.unLoading = true;

            this.$store.dispatch('user/unBindUser').then(() => {
              this.$toast('用户解绑成功...');
              this.auth = false;
              this.item = {};
            }).finally(() => {
              this.unLock = false;
              this.unLoading = false;
            });
          },
            refreshValidateCode() {
                this.imageSrc = this.$APP_ROOT + "/api/authority/weixin/generateCode?t=" + new Date().getTime();
            },
            selectSmsValidateCode() {
                if (!this.item.mobile || !this.item.name || !this.item.certNo) {
                    this.$toast('请输入真实姓名/身份证号码/手机号码...');
                    return;
                }
                selectSmsValidateCode(this.item).then(res => {
                    if (res.data) {
                        this.sms = !this.sms;
                    }
                });
            },
            timeFinished() {
                this.$refs.count.reset();
                this.sms = !this.sms;
            }
        }
    }
</script>
